/**
 * Socket observability debug helpers. Development-only, zero production impact.
 */
if (typeof window !== "undefined") {
  window.__socketStats = window.__socketStats || {};
  window.__socketStatsSlow = window.__socketStatsSlow || {};
  window.__socketLastEvent = window.__socketLastEvent || {};
  window.__socketConnection = window.__socketConnection || {};

  window.resetSocketStats = () => {
    window.__socketStats = {};
    window.__socketStatsSlow = {};
    window.__socketLastEvent = {};
    window.__socketConnection = {};
    window.__socketLastActivity = null;
  };

  window.printSocketStats = () => {
    console.table(window.__socketStats || {});
  };

  window.inspectSocketHealth = () => ({
    stats: window.__socketStats,
    slow: window.__socketStatsSlow,
    lastEvent: window.__socketLastEvent,
    connection: window.__socketConnection,
    lastActivity: window.__socketLastActivity,
  });

  window.printSocketHealth = () => {
    console.log("Socket connection:", window.__socketConnection);
    console.table(window.__socketStats || {});
  };
}
